import Swal from 'sweetalert2'

export const swalInfo = Swal.mixin({
  icon: 'info',
})

export const swalConfirm = Swal.mixin({
  icon: 'question',
  showCancelButton: true,
  confirmButtonText: 'はい',
  cancelButtonText: 'キャンセル',
  focusConfirm: false,
  focusCancel: true,
})

export const swalWarning = Swal.mixin({
  icon: 'warning',
})

export const swalError = Swal.mixin({
  icon: 'error',
})

export const swalSuccess = Swal.mixin({
  icon: 'success',
})

export const swalToast = Swal.mixin({
  icon: 'success',
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 3000,
  didOpen: toast => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export const swalErrorToast = Swal.mixin({
  icon: 'error',
  toast: true,
  position: 'top',
  showConfirmButton: false,
  timer: 3000,
  didOpen: toast => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
